import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import { useStyles } from 'components/desktop/_general/Input/InputExtensions/InputTranslateButton/InputTranslateButton.tss';
import ENTITLEMENTS from 'enums/entitlements';
import { ILanguageNavigationPill } from 'interfaces/ILanguageNavigationPill';

interface IProps {
	navigationPills: ILanguageNavigationPill[];
	selectedLanguage: string;
	translatable: boolean;
	handleSelectLanguage: (e: any, selectedLanguage: string) => void;
	onTranslateClick?: () => void;
	dataComponentType?: string;
	dataComponentKey?: string;
}

const LanguageNavigationPills = (props: IProps) => {
	const { classes } = useStyles();
	const renderGlobe = (key: number): JSX.Element => {
		return (
			<span
				key={key}
				className={['input-group-text', classes.button].join(' ')}
				style={{ cursor: 'pointer', }}
				onClick={props.onTranslateClick}
			>
				<FontAwesomeIcon icon={faGlobe} className={classes.icon} />
			</span>
		);
	};

	return (
		<>
			<RenderIf entitlements={[ENTITLEMENTS.LANGUAGES]}>
				<div
					className="d-flex row align-items-center"
					data-component-type={props.dataComponentType}
					data-component-key={props.dataComponentKey}
				>
					<span style={{fontSize: '0.8rem', opacity: '0.7'}}>Recipe language</span>
					<div className="d-flex">
					<select
					
						className="form-select"
						value={props.selectedLanguage}
						onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
							props.handleSelectLanguage(e, e.target.value)
						}
						aria-label="Select language"
						id="language-select"
					>
						{props.navigationPills.map((navPill, i) => (
							<option key={i} value={navPill.cultureCode}>
								{navPill.name}
							</option>
						))}
					</select>
					{props.translatable && (
						<RenderIf entitlements={[ENTITLEMENTS.TRANSLATION_SERVICE]}>
							<>
								{/* Find the selected navPill index and render the globe if needed */}
								{renderGlobe(
									props.navigationPills.findIndex(
										(p) => p.cultureCode === props.selectedLanguage
									)
								)}
							</>
						</RenderIf>
					)}
					</div>
				</div>
			</RenderIf>
			<div className="tab-content" id="nav-tabContent">
				{props.navigationPills.map((navPill, i) => (
					<div
						key={i}
						className={
							navPill.cultureCode === props.selectedLanguage
								? 'tab-pane fade show active'
								: 'tab-pane fade show'
						}
						id={navPill.nameId}
						role="tabpanel"
						aria-labelledby={navPill.nameId + '-tab'}
					>
						{navPill.content}
					</div>
				))}
			</div>
		</>
	);
};

export default LanguageNavigationPills;
